'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.getOwnPropertyDescriptors === 'function' ? Object.getOwnPropertyDescriptors : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/object.getownpropertydescriptors/polyfill.js
// module id = 256
// module chunks = 0